export const FETCH_PLANETS = 'FETCH_PLANETS';
export const FETCH_PLANETS_START = 'FETCH_PLANETS_START';
export const FETCH_PLANETS_SUCCESS = 'FETCH_PLANETS_SUCCESS';
export const FETCH_PLANETS_FAIL = 'FETCH_PLANETS_FAIL';

export const FETCH_PLANET = 'FETCH_PLANET';
export const FETCH_PLANET_START = 'FETCH_PLANET_START';
export const FETCH_PLANET_SUCCESS = 'FETCH_PLANET_SUCCESS';
export const FETCH_PLANET_FAIL = 'FETCH_PLANET_FAIL';

export const FETCH_STARSHIPS = 'FETCH_STARSHIPS';
export const FETCH_STARSHIPS_START = 'FETCH_STARSHIPS_START';
export const FETCH_STARSHIPS_SUCCESS = 'FETCH_STARSHIPS_SUCCESS';
export const FETCH_STARSHIPS_FAIL = 'FETCH_STARSHIPS_FAIL';

export const FETCH_STARSHIP = 'FETCH_STARSHIP';
export const FETCH_STARSHIP_START = 'FETCH_STARSHIP_START';
export const FETCH_STARSHIP_SUCCESS = 'FETCH_STARSHIP_SUCCESS';
export const FETCH_STARSHIP_FAIL = 'FETCH_STARSHIP_FAIL';

export const FETCH_VEHICLES = 'FETCH_VEHICLES';
export const FETCH_VEHICLES_START = 'FETCH_VEHICLES_START';
export const FETCH_VEHICLES_SUCCESS = 'FETCH_VEHICLES_SUCCESS';
export const FETCH_VEHICLES_FAIL = 'FETCH_VEHICLES_FAIL';

export const FETCH_VEHICLE = 'FETCH_VEHICLE';
export const FETCH_VEHICLE_START = 'FETCH_VEHICLE_START';
export const FETCH_VEHICLE_SUCCESS = 'FETCH_VEHICLE_SUCCESS';
export const FETCH_VEHICLE_FAIL = 'FETCH_VEHICLE_FAIL';

export const FETCH_PEOPLE = 'FETCH_PEOPLE';
export const FETCH_PEOPLE_START = 'FETCH_PEOPLE_START';
export const FETCH_PEOPLE_SUCCESS = 'FETCH_PEOPLE_SUCCESS';
export const FETCH_PEOPLE_FAIL = 'FETCH_PEOPLE_FAIL';

export const FETCH_PERSON = 'FETCH_PERSON';
export const FETCH_PERSON_START = 'FETCH_PERSON_START';
export const FETCH_PERSON_SUCCESS = 'FETCH_PERSON_SUCCESS';
export const FETCH_PERSON_FAIL = 'FETCH_PERSON_FAIL';

export const FETCH_FILMS = 'FETCH_FILMS';
export const FETCH_FILMS_START = 'FETCH_FILMS_START';
export const FETCH_FILMS_SUCCESS = 'FETCH_FILMS_SUCCESS';
export const FETCH_FILMS_FAIL = 'FETCH_FILMS_FAIL';

export const FETCH_FILM = 'FETCH_FILM';
export const FETCH_FILM_START = 'FETCH_FILM_START';
export const FETCH_FILM_SUCCESS = 'FETCH_FILM_SUCCESS';
export const FETCH_FILM_FAIL = 'FETCH_FILM_FAIL';

export const FETCH_SPECIES = 'FETCH_SPECIES';
export const FETCH_SPECIES_START = 'FETCH_SPECIES_START';
export const FETCH_SPECIES_SUCCESS = 'FETCH_SPECIES_SUCCESS';
export const FETCH_SPECIES_FAIL = 'FETCH_SPECIES_FAIL';

export const FETCH_SPECIE = 'FETCH_SPECIE';
export const FETCH_SPECIE_START = 'FETCH_SPECIE_START';
export const FETCH_SPECIE_SUCCESS = 'FETCH_SPECIE_SUCCESS';
export const FETCH_SPECIE_FAIL = 'FETCH_SPECIE_FAIL';
